export interface ITypeDescriptionData {
    category: string;
    categoryBgColor: string;
    codeSoma: string;
    name: string;
    bgColor: string;
    description: string;
    graphImage: string;
    imageMale: string;
    imageFemale: string;
    linkToPage: string;
  }
  
  export const typeDescriptionDatas: ITypeDescriptionData[] = [
    {
      category: "Mesomorph",
      categoryBgColor: "#B76060",
      codeSoma: "EnM",
      name: "Endomorphic Mesomorph",
      bgColor: "#B76060",
      description: "Mesomorphy is dominant and endomorphy is greater than ectomorphy.",
      graphImage: "EnM_graph",
      imageMale: "EnM_man",
      imageFemale: "EnM_woman",
      linkToPage: "/EnM",

    },
    {
      category: "Mesomorph",
      categoryBgColor: "#B76060",
      codeSoma: "BM",
      name: "Balanced Mesomorph",
      bgColor: "#B76060",
      description: "Mesomorphy is dominant, endomorphy and ectomorphy are less and equal (or do not differ by more than one-half unit).",
      graphImage: "BM_graph",
      imageMale: "BM_man",
      imageFemale: "BM_woman",
      linkToPage: "/BM",

    },
    {
      category: "Mesomorph",
      categoryBgColor: "#B76060",
      codeSoma: "EcM",
      name: "Ectomorphic Mesomorph",
      bgColor: "#B76060",
      description: "Mesomorphy is dominant, and ectomorphy is greater than endomorphy.",
      graphImage: "EcM_graph",
      imageMale: "EcM_man",
      imageFemale: "EcM_woman",
      linkToPage: "/EcM",
    },
    {
      category: "Hybrid",
      categoryBgColor: "#56A278",
      codeSoma: "M-Ec",
      name: "Mesomorph-Ectomorph",
      bgColor: "#56A278",
      description: "Mesomorphy and ectomorphy are equal (or do not differ by more than one-half unit); and endomorphy is lower.",
      graphImage: "M-Ec_graph",
      imageMale: "BM_man",
      imageFemale: "BM_woman",
      linkToPage: "/BM",

    },
    {
      category: "Ectomorph",
      categoryBgColor: "#DCB051",
      codeSoma: "MEc",
      name: "Mesomorphic Ectomorph",
      bgColor: "#DCB051",
      description: "Ectomorphy is dominant; and mesomorphy is greater than endomorphy.",
      graphImage: "MEc_graph",
      imageMale: "MEc_man",
      imageFemale: "MEc_woman",
      linkToPage: "/MEc",

    },
    {
      category: "Ectomorph",
      categoryBgColor: "#DCB051",
      codeSoma: "BEc",
      name: "Balanced Ectomorph",
      bgColor: "#DCB051",
      description: "Ectomorphy is dominant; endomorphy and mesomorphy are equal and lower (or do not differ by more than one-half unit).",
      graphImage: "BEc_graph",
      imageMale: "BEc_man",
      imageFemale: "BEc_woman",
      linkToPage: "/BEc",
    },
    {
      category: "Ectomorph",
      categoryBgColor: "#DCB051",
      codeSoma: "EnEc",
      name: "Endomorphic Ectomorph",
      bgColor: "#DCB051",
      description: "Ectomorphy is domninant; and endomorphy is greater than mesomorphy.",
      graphImage: "EnEc_graph",
      imageMale: "EnEc_man",
      imageFemale: "EnEc_woman",
      linkToPage: "/EnEc",
    },
    {
      category: "Hybrid",
      categoryBgColor: "#56A278",
      codeSoma: "En-Ec",
      name: "Endomorph-Ectomorph",
      bgColor: "#56A278",
      description: "Endomorphy and ectomorphy are equal (or do not differ by more than one-half unit); and mesomorphy is lower.",
      graphImage: "En-Ec_graph",
      imageMale: "En-Ec_man",
      imageFemale: "En-Ec_woman",
      linkToPage: "/En-Ec",
    },
    {
      category: "Endomorph",
      categoryBgColor: "#6C4D7B",
      codeSoma: "EcEn",
      name: "Ectomorphic Endomorph",
      bgColor: "#6C4D7B",
      description: "Endomorphy is dominant; and ectomorphy is greater than mesomorphy.",
      graphImage: "EcEn_graph",
      imageMale: "EcEn_man",
      imageFemale: "EcEn_woman",
      linkToPage: "/EcEn",
    },
    {
      category: "Endomorph",
      categoryBgColor: "#6C4D7B",
      codeSoma: "BEn",
      name: "Balanced Endomorph",
      bgColor: "#6C4D7B",
      description: "Endomorphy is dominant and mesomorphy and ectomorphy are equal (or do not differ by more than one-half unit).",
      graphImage: "BEn_graph",
      imageMale: "BEn_man",
      imageFemale: "BEn_woman",
      linkToPage: "/BEn",
    },
    {
      category: "Endomorph",
      categoryBgColor: "#6C4D7B",
      codeSoma: "MEn",
      name: "Mesomorphic Endomorph",
      bgColor: "#6C4D7B",
      description: "Endormorphy is dominant and mesomorphy is greater than ectomorphy.",
      graphImage: "MEn_graph",
      imageMale: "MEn_man",
      imageFemale: "MEn_woman",
      linkToPage: "/MEn",

    },
    {
      category: "Hybrid",
      categoryBgColor: "#56A278",
      codeSoma: "M-En",
      name: "Mesomorph-Endomorph",
      bgColor: "#56A278",
      description: "Endomorphy and mesomorphy are equal (or do not differ by more than one-half unit), and ectomorphy is smaller.",
      graphImage: "M-En_graph",
      imageMale: "M-En_man",
      imageFemale: "M-En_woman",
      linkToPage: "/M-En",
    },
    {
      category: "Central",
      categoryBgColor: "#4298B4",
      codeSoma: "C",
      name: "Central",
      bgColor: "#4298B4",
      description: "No component differs by more than one unit from the other two, and consists of ratings of 2, 3, or 4.",
      graphImage: "C_graph",
      imageMale: "C_man",
      imageFemale: "C_woman",
      linkToPage: "/C",
    },
  ];